export const SET_THEME = '@app/SET_THEME';
export const SET_LANGUAGE = '@app/SET_LANGUAGE';
